// extracted by mini-css-extract-plugin
export default {"container":"not_found_container__le6H1","text":"not_found_text__wS1Gf"};